module.exports = __webpack_public_path__ + "img/antes_despues_289.8220eb2a.png";